import { useEffect, useState } from 'react';

export const useLocalStorageArray = (key, initialValue) => {
  const [data, setData] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedData = window.localStorage.getItem(key);
      return storedData ? JSON.parse(storedData) : initialValue;
    }

    return null;
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(key, JSON.stringify(data));
    }
  }, [key, data]);

  const addItem = item => {
    setData(prevData => [...prevData, item]);
  };

  /**
   * Remove one object in the localStorage
   * array at the given index.
   * @param {number} index
   */
  const removeItem = index => {
    setData(prevData => {
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };

  /**
   * Update one object in the localStorage
   * array at the given index with the given object.
   * @param {number} index
   * @param {object} newItem
   */
  const updateItem = (index, newItem) => {
    setData(prevData => {
      const newData = [...prevData];
      newData[index] = newItem;
      return newData;
    });
  };

  /**
   * Remove all items from the localStorage.
   */
  const clearItems = () => {
    setData(initialValue);
  };

  /**
   * Get a specific item from the localStorage
   * at the given index.
   *
   * @param {number} index
   * @returns {{id: string, timestamp: number, isFavorite: boolean}}
   */
  const getItem = index => {
    return data?.length ? data[index] : null;
  };

  /**
   * Get the entire list of items from the localStorage.
   * @returns {Array.<{id: string, timestamp: number, isFavorite: boolean}>}
   */
  const getItems = () => {
    if (typeof window !== 'undefined') {
      const storedData = window.localStorage.getItem(key);
      const newData = storedData ? JSON.parse(storedData) : initialValue;
      setData(newData);
      return newData;
    }

    return null;
  };

  return [data, addItem, removeItem, updateItem, clearItems, getItem, getItems];
};
